// src/components/Products.js
import React from 'react';
import Ideapng from '../resorcesfiles/images/idea.png';
import './Products.css';
import Mainmastet from '../masterpage/Mainmastet';
import P80 from '../resorcesfiles/ideak/p80.jpg'
import U300 from '../resorcesfiles/ideak/u300.jpg'
import Cp30 from '../resorcesfiles/ideak/cp30.jpg'
import C72 from '../resorcesfiles/ideak/c72.jpg'
import Antenna from '../resorcesfiles/ideak/antenna.jpg'
import Laundrytags from '../resorcesfiles/ideak/laundrytags.jpeg'
import Keyfob from '../resorcesfiles/ideak/keyfob.jpeg'
import AnimalTag from '../resorcesfiles/ideak/animaltag.png'
import { Link } from 'react-router-dom';




const products = [
  {
    img:P80,
    shortName: 'P80',
    fullName: 'P80 Industrial Tablet (Android 13)',
    description: 'More Power, More Features and More Versatility',
    paths:'ProductDetailsP'
  },
  {
    img:U300,
    shortName: 'U300',
    fullName: 'Fixed RFID Reader (Android 11)',
    description: 'Android 11 OS, Multiple Interfaces, More Powerful UHF RFID Performance',  
    paths:'ProductDetailsU'


  },
  {
    img:Cp30,
    shortName: 'Cp30',
    fullName: 'CP30 RFID Printer',
    description: 'Powerful RFID and Barcode Printing, Speedy and Highly Secured',
    paths:'ProductDetailsCP'
  },
  {
    img:C72,
    shortName: 'C72',
    fullName: 'C72 UHF RFID Reader (Android 11/13)',
    description: 'Industry-leading RFID Performance',
    paths:'ProductDetails'
  },
  {
    img:Antenna,
    shortName: 'Ant-RC09 ',
    fullName: 'Ant-RC09 9dBi Panel Antenna',
    description: 'Environmental Adaptability, Easy Installation',
    paths:'ProductDetailsANT'
  },


  {
    img:Laundrytags,
    shortName: 'Laundry',
    fullName: 'Laundry Tags',
    description: 'WaterProof',
    paths:''
  },
  {
    img:Keyfob,
    shortName: 'UHF',
    fullName: 'UHF Gen 2 860-960 MHz RFID Key Fob tag',
    description: 'Lightweight, harder and more durable',
    paths:''
  },
  {
    img:AnimalTag,
    shortName: '125 kHz',
    fullName: '125 kHz Glass Tube RFID Tag',
    description: 'Implanting into pets to laundry management.',
    paths:''
  },




];

const Products = () => {
  return (
    <Mainmastet content={<>
    
    <div className="products-container">
        <div style={{textAlign:'center'}}>
        <h1 style={{fontFamily:'fantasy'}}>OUR PRODUCTS</h1>
        </div>
      <div className="products-grid">
        {products.map((product, index) => (
        <Link to={`/${product.paths}`} key={index} className="product-item" style={{textDecoration:'none'}} > 
          {/* <div > */}
            <img src={product.img} alt={product.fullName} className="product-image" />
            {/* <h2 className="product-shortname">{product.shortName}</h2> */}
            <h3 className="product-fullname">{product.fullName}</h3>
            <p className="product-description">{product.description}</p>
          {/* </div> */}
        </Link>
    
        ))}
      </div>

      <div style={{height:'50px'}}></div>

    </div>

    </>} />
  );
};

export default Products;
